import {fileExtension} from '../file_utils.ts';

const NET_SEARCH_DISABLED_EXTENSIONS = new Set(['kicad_sch', 'schdoc', 'prj', 'prjpcb']);

/**
 * Returns true for schematic formats (KiCad, Altium) where net search
 * should be suppressed in the component search UI. Includes .prj because
 * multi-page project views use the project file path as headPath.
 */
export function isNetSearchDisabledSchematic(path: string): boolean {
  return NET_SEARCH_DISABLED_EXTENSIONS.has(fileExtension(path).toLowerCase());
}
